import React from "react"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import Layout from "../components/Layout"
import { Helmet } from "react-helmet"
import styled from "styled-components"
import colors from "../styles/colors"
import text from "../styles/text"
import media from "../styles/media"
import {
  TwitterShareButton,
  FacebookShareButton,
  LinkedinShareButton,
} from "react-share"

import TwitterIcon from "images/Blog/Twitter.png"
import FBIcon from "images/Blog/Facebook.png"
import LinkedInIcon from "images/Blog/LinkedIn.png"
import PostSection from "../components/PageSection"
import ContentWidth from "components/ContentWidth"

const PostSections = ({ content }) => {
  return (
    <div className="page-content">
      {content?.sections?.map((section, i) => (
        <PostSection key={i} section={section} />
      ))}
    </div>
  )
}

const PostTemplate = ({ data: { post }, pageContext }) => {
  const postSections = post.sections.sections === null

  return (
    <>
      {postSections ? (
        <Layout slug={pageContext.slug}>
          <Helmet>
            <title>{post.title}| PrinterLogic Blog</title>
            <meta name="description" content={post.metaDescription} />
          </Helmet>
          <OutsideWrapper>
            <ArticleWrapper itemScope itemType="http://schema.org/Article">
              <IntroContainer>
                <TitleContainer>
                  <ArticleTitle itemProp="headline">
                    {parse(post.title)}
                  </ArticleTitle>
                  <SocialDiv>
                    <TwitterShareButton
                      url={`https://www.printerlogic.com/blog/${post.slug}`}
                      title={post.title}
                    >
                      <SocialIcon alt="social icon" src={TwitterIcon} />
                    </TwitterShareButton>

                    <FacebookShareButton
                      url={`https://www.printerlogic.com/blog/${post.slug}`}
                      title={post.title}
                    >
                      <SocialIcon alt="social icon" src={FBIcon} />
                    </FacebookShareButton>

                    <LinkedinShareButton
                      url={`https://www.printerlogic.com/blog/${post.slug}`}
                      title={post.title}
                    >
                      <SocialIcon alt="social icon" src={LinkedInIcon} />
                    </LinkedinShareButton>
                  </SocialDiv>
                </TitleContainer>
                <AuthorContainer>
                  <AuthorImg
                    src={post.author.node.avatar.url}
                    alt="author avatar"
                  />
                  <Author>{post.author.node.name}</Author>
                  <PostDate>{post.date}</PostDate>
                </AuthorContainer>
              </IntroContainer>
              {!!post.content && (
                <ArticleBody itemProp="articleBody">
                  {parse(post.content)}
                </ArticleBody>
              )}
              <AuthorDescription>
                {post.author.node.description}
              </AuthorDescription>
            </ArticleWrapper>
          </OutsideWrapper>
        </Layout>
      ) : (
        <Layout slug={pageContext.slug}>
          <ContentWidth>
            <Helmet>
              <title>{post.title}| PrinterLogic Blog</title>
              <meta name="description" content={post.metaDescription} />
            </Helmet>
            <ArticleWrapper>
              <IntroContainer>
                <TitleContainer>
                  <ArticleTitle itemProp="headline">
                    {parse(post.title)}
                  </ArticleTitle>
                  <SocialDiv>
                    <TwitterShareButton
                      url={`https://www.printerlogic.com/blog/${post.slug}`}
                      title={post.title}
                    >
                      <SocialIcon alt="social icon" src={TwitterIcon} />
                    </TwitterShareButton>

                    <FacebookShareButton
                      url={`https://www.printerlogic.com/blog/${post.slug}`}
                      title={post.title}
                    >
                      <SocialIcon alt="social icon" src={FBIcon} />
                    </FacebookShareButton>

                    <LinkedinShareButton
                      url={`https://www.printerlogic.com/blog/${post.slug}`}
                      title={post.title}
                    >
                      <SocialIcon alt="social icon" src={LinkedInIcon} />
                    </LinkedinShareButton>
                  </SocialDiv>
                </TitleContainer>
                <AuthorContainer>
                  <AuthorImg
                    src={post.author.node.avatar.url}
                    alt="author avatar"
                  />
                  <Author>{post.author.node.name}</Author>
                  <PostDate>{post.date}</PostDate>
                </AuthorContainer>
              </IntroContainer>
            </ArticleWrapper>
            <PostSections content={post.sections} />
          </ContentWidth>
        </Layout>
      )}
    </>
  )
}

const PostDate = styled.p`
  ${text.bodyMd};
  margin-left: auto;
`
const Author = styled.p`
  ${text.mdBold};
`
const AuthorImg = styled.img`
  border-radius: 5.556vw;
  width: 5.556vw;
  height: 5.556vw;

  ${media.fullWidth} {
    border-radius: 80px;
    width: 80px;
    height: 80px;
  }

  ${media.tablet} {
    border-radius: 7.813vw;
    width: 7.813vw;
    height: 7.813vw;
  }

  ${media.mobile} {
    border-radius: 18.692vw;
    width: 18.692vw;
    height: 18.692vw;
  }
`
const AuthorContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1.458vw;

  ${media.fullWidth} {
    gap: 21px;
  }

  ${media.tablet} {
    gap: 2.051vw;
  }

  ${media.mobile} {
    gap: 4.907vw;
  }
`
const SocialIcon = styled.img`
  width: 2.083vw;
  height: 2.083vw;

  ${media.fullWidth} {
    width: 30px;
    height: 30px;
  }

  ${media.tablet} {
    width: 2.93vw;
    height: 2.93vw;
  }

  ${media.mobile} {
    width: 7.009vw;
    height: 7.009vw;
  }
`

const SocialLink = styled.a``
const SocialDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: auto;
  gap: 1.389vw;
  margin-top: 0.694vw;

  ${media.fullWidth} {
    gap: 20px;
    margin-top: 10px;
  }

  ${media.tablet} {
    gap: 1.953vw;
    margin-top: 0.977vw;
  }

  ${media.mobile} {
    flex-direction: row;
    gap: 4.673vw;
    margin-top: 4.673vw;
    margin-left: unset;
  }
`
const ArticleTitle = styled.h1`
  color: ${colors.primaryPurple};
  ${text.h1};
  width: 47.222vw;

  ${media.fullWidth} {
    width: 680px;
  }

  ${media.tablet} {
    width: 66.406vw;
  }

  ${media.mobile} {
    width: 87.85vw;
  }
`
const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  ${media.mobile} {
    flex-direction: column;
  }
`
const IntroContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5.556vw;
  margin-bottom: 1.667vw;

  ${media.fullWidth} {
    gap: 80px;
    margin-bottom: 24px;
  }

  ${media.tablet} {
    gap: 7.813vw;
    margin-bottom: 2.344vw;
  }

  ${media.mobile} {
    gap: 18.692vw;
    margin-bottom: 5.607vw;
  }
`
const ArticleWrapper = styled.div`
  height: auto;
  width: 63.264vw;
  margin-top: 7.778vw;
  margin-bottom: 7.153vw;

  ${media.fullWidth} {
    width: 911px;
    margin-top: 112px;
    margin-bottom: 103px;
  }

  ${media.tablet} {
    width: 88.965vw;
    margin-top: 10.938vw;
    margin-bottom: 10.059vw;
  }

  ${media.mobile} {
    width: 87.85vw;
    margin-top: 26.168vw;
    margin-bottom: 24.065vw;
  }
`

const OutsideWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
`
const ArticleBody = styled.section`
  padding: 1.389vw;

  ${media.fullWidth} {
    padding: 20px;
  }
  ${media.tablet} {
    padding: 1.953vw;
  }
  ${media.mobile} {
    padding: 5.333vw;
  }

  h1 {
    ${text.h1};
  }
  h2 {
    ${text.h3};
  }
  h3 {
    ${text.h3};
  }
  h4 {
    ${text.h4};
  }

  p,
  li {
    ${text.bodyMd};
    margin-top: 1.042vw;

    ${media.fullWidth} {
      margin-top: 15px;
    }

    ${media.tablet} {
      margin-top: 1.465vw;
    }

    ${media.mobile} {
      margin-top: 3.505vw;
    }
  }

  ul,
  ol {
    margin-left: 3.472vw;
    margin-top: 1.042vw;

    ${media.fullWidth} {
      margin-left: 50px;
      margin-top: 15px;
    }

    ${media.tablet} {
      margin-left: 4.883vw;
      margin-top: 1.465vw;
    }

    ${media.mobile} {
      margin-left: 11.682vw;
      margin-top: 3.505vw;
    }
  }

  img {
    height: auto;
    max-width: 100%;
  }
`

const AuthorDescription = styled.p`
  color: ${colors.grey700};
  font-style: italic;
  ${text.p};
`

export default PostTemplate

export const pageQuery = graphql`
  query BlogPostById($id: String!) {
    post: wpPost(id: { eq: $id }) {
      id
      excerpt
      slug
      content
      title
      date(formatString: "MMMM DD, YYYY")
      featuredImage {
        node {
          altText
          sourceUrl
        }
      }
      author {
        node {
          name
          description
          avatar {
            url
          }
        }
      }
      sections {
        sections {
          ... on WpPost_Sections_Sections_ImageContentBlock {
            fieldGroupName
            backgroundColor
            card
            bodyCopy
            contentSide
            eyebrow
            linkText
            linkUrl
            fieldGroupName
            formId
            headline
            textColor
            image {
              sourceUrl
            }
            imageTop
            bodyCopy
            formId
            linkText
            linkUrl
            spacing
          }
          ... on WpPost_Sections_Sections_PillCta {
            fieldGroupName
            headline
            body
            buttonText
            buttonUrl
            backgroundImage {
              sourceUrl
            }
            spacing
          }
          ... on WpPost_Sections_Sections_CustomerTestimonials {
            fieldGroupName
            backgroundColor
            spacing
            testimonial {
              largeQuote
              name
              rating {
                sourceUrl
              }
              testimonial
            }
          }
          ... on WpPost_Sections_Sections_Features {
            eyebrow
            fieldGroupName
            variation
            introBody
            header
            backgroundColor
            textColor
            badges {
              badge {
                sourceUrl
              }
              badgeName
              badgeCopy
            }
            image {
              sourceUrl
            }
            imageAlt
            video
            videoThumbnail {
              sourceUrl
            }
            cards {
              cardImage {
                sourceUrl
              }
              gradientHeader
              eyebrow
              header
              bodyCopy
              linkText
              linkUrl
            }
            grid {
              icon {
                sourceUrl
              }
              header
              bodyCopy
            }
            comparison {
              sideOneHeader
              sideOneList {
                listItem
              }
              sideTwoHeader
              sideTwoList {
                listItem
              }
            }
            stats {
              stat
              statCopy
              linkText
              linkUrl
            }
            spacing
          }
          ... on WpPost_Sections_Sections_HighlightedCta {
            backgroundColor
            bodyCopy
            buttonColor
            ctaLink
            ctaText
            fieldGroupName
            textColor
          }
          ... on WpPost_Sections_Sections_ImageCta {
            fieldGroupName
            textColor
            backgroundImages {
              sourceUrl
            }
            contentSide
            header
            linkText
            linkUrl
            spacing
          }
          ... on WpPost_Sections_Sections_HighlightedCtaCard {
            fieldGroupName
            ctaLink
            ctaText
            textColor
            headline
            body
          }
          ... on WpPost_Sections_Sections_MultiColumnValueProp {
            backgroundColor
            bodyCopy
            buttonColor
            ctaLink
            ctaText
            fieldGroupName
            headline
            textColor
            columns {
              bodyCopy
              fieldGroupName
              headline
              icon {
                sourceUrl
              }
              link
            }
          }
          ... on WpPost_Sections_Sections_MultiColumnMutliRowValueProp {
            backgroundColor
            bodyCopy
            buttonColor
            ctaLink
            ctaText
            fieldGroupName
            headline
            textColor
            columns {
              bodyCopy
              fieldGroupName
              headline
              icon {
                sourceUrl
              }
              link
            }
          }
          ... on WpPost_Sections_Sections_CodeArea {
            fieldGroupName
            codeAreaField
            spacing
          }
          ... on WpPost_Sections_Sections_TableOfContents {
            backgroundColor
            fieldGroupName
            textColor
            columns {
              bodyCopy
              fieldGroupName
              headline
              link
            }
          }
          ... on WpPost_Sections_Sections_PartnerStatic {
            backgroundColor
            bodyCopy
            buttonColor
            ctaLink
            ctaText
            fieldGroupName
            headline
            textColor
            columns {
              bodyCopy
              fieldGroupName
              headline
              icon {
                sourceUrl
              }
              link
            }
          }
          ... on WpPost_Sections_Sections_ThreeGrid {
            backgroundColor
            bodyCopy
            buttonColor
            eyebrow
            ctaLink
            ctaText
            fieldGroupName
            headline
            textColor
            sectionHeader
            columns {
              link
              headline
              fieldGroupName
              bodyCopy
              icon {
                sourceUrl
              }
            }
          }
          ... on WpPost_Sections_Sections_DataCard {
            backgroundColor
            fieldGroupName
            headline
            source
            textColor
            columns {
              bodyCopy
              fieldGroupName
              stat
            }
          }
          ... on WpPost_Sections_Sections_StatGrid {
            backgroundColor
            fieldGroupName
            headingCopy
            textColor
            columns {
              bodyCopy
              fieldGroupName
              headline
              icon {
                sourceUrl
              }
            }
          }
          ... on WpPost_Sections_Sections_Tabs {
            backgroundColor
            bodyCopy
            fieldGroupName
            headline
            textColor
            columns {
              bodyCopy
              fieldGroupName
              title
              bodyImage {
                sourceUrl
              }
            }
          }
          ... on WpPost_Sections_Sections_CardComponent {
            backgroundColor
            bodyCopy
            fieldGroupName
            eyebrow
            headline
            textColor
            columns {
              cardEyebrow
              bodyCopy
              fieldGroupName
              cardEyebrow
              headline
              link
              icon {
                sourceUrl
              }
            }
          }
          ... on WpPost_Sections_Sections_AccordionSection {
            backgroundColor
            bodyCopy
            fieldGroupName
            headline
            textColor
            accordion {
              bodyCopy
              fieldGroupName
              headline
              image {
                sourceUrl
              }
            }
          }
          ... on WpPost_Sections_Sections_TestimonialCarousel {
            fieldGroupName
            mode
            quotes {
              quote
              author
              position
              location
            }
            linkText
            linkSrc
            spacing
          }
          ... on WpPost_Sections_Sections_ByTheNumbers {
            backgroundColor
            fieldGroupName
            headlineNumber
            eyebrow
            body
            textColor
            columns {
              description
              fieldGroupName
              indicator
              number
            }
          }
          # Look at the featured Resource GraphQL
          # ... on WpPost_Sections_Sections_FeaturedResource {
          #   fieldGroupName
          #   backgroundColor
          #   bodyCopy
          #   textColor
          #   resources{
          #     resource{
          #       wordpressId
          #       postTitle
          #       postName
          #       postType
          #       acf {
          #         resource
          #       }
          #     }
          #   }
          # }
          ... on WpPost_Sections_Sections_SimpleCenteredContent {
            fieldGroupName
            backgroundColor
            textColor
            eyebrowCopy
            headline
            bodyCopy
            image {
              sourceUrl
            }
            mobileImage {
              sourceUrl
            }
            formId
            linkText
            linkUrl
            button
            video
            videoThumbnail {
              sourceUrl
            }
          }
          ... on WpPost_Sections_Sections_BottomCta {
            fieldGroupName
            backgroundColor
            textColor
            fwBackgroundImage {
              sourceUrl
            }
            headline
            bodyCopy
            buttonText
            buttonLink
            spacing
          }
          ... on WpPost_Sections_Sections_Logos {
            fieldGroupName
            backgroundColor
            cardColor
            spacing
            mainSide
            mainLogo {
              sourceUrl
            }
            mainHeadline
            mainBody
            mainLinkText
            mainLink
            logosCategory
            logos {
              sourceUrl
            }
          }
          ... on WpPost_Sections_Sections_G2Ads {
            fieldGroupName
          }
          ... on WpPost_Sections_Sections_G2Banner {
            fieldGroupName
            spacing
          }
          ... on WpPost_Sections_Sections_LogoCube {
            fieldGroupName
            header
            logos {
              alt
              image {
                sourceUrl
              }
            }
          }
          ... on WpPost_Sections_Sections_ChromeLogos {
            fieldGroupName
          }
          ... on WpPost_Sections_Sections_StyledList {
            fieldGroupName
            header
            kicker
            pointContent {
              content
            }
            points
          }
          ... on WpPost_Sections_Sections_SimpleVideo {
            backgroundColor
            bodyCopy
            fieldGroupName
            formId
            textColor
            video
            image {
              sourceUrl
            }
          }
          ... on WpPost_Sections_Sections_SectionHeading {
            backgroundColor
            bodyCopy
            fieldGroupName
            textColor
          }
          ... on WpPost_Sections_Sections_FlexibleText {
            backgroundColor
            bodyCopy
            fieldGroupName
            textColor
            spacing
          }
          ... on WpPost_Sections_Sections_AnimatedQuote {
            fieldGroupName
            headline
            linkText
            linkUrl
            quotes {
              quote
              person
            }
          }
          ... on WpPost_Sections_Sections_Testimonial {
            fieldGroupName
            quoteBody
            name
            asideImage
            image {
              sourceUrl
            }
            companyAndTitle
            location
            mode
            largeQuote
            ctaText
            ctaLink
          }
          ... on WpPost_Sections_Sections_AsideTestimonial {
            fieldGroupName
            quoteBody
            personQuoted
            image {
              sourceUrl
            }
            callout
            quoteEyebrow
            headline
            body
            linkText
            linkCta
            quoteCardBackground
            backgroundColor
          }
          ... on WpPost_Sections_Sections_VideoHighlights {
            backgroundColor
            featuredVideoId
            fieldGroupName
            textColor
            featuredVideoThumbnail {
              sourceUrl
            }
            otherHighlightVideos {
              videoId
              fieldGroupName
              videoTitle
              videoThumbnail {
                sourceUrl
              }
            }
          }
          ... on WpPost_Sections_Sections_PinScroll {
            fieldGroupName
            items {
              bodyContent
              bodyHeadline
              ctaLink
              ctaText
              points {
                text
              }
            }
            topics {
              headline
            }
          }
          ... on WpPost_Sections_Sections_SplitForm {
            backgroundColor
            body
            fieldGroupName
            formId
            header
          }
          # ... on Page_Sections_Sections_CarouselModule {
          #   backgroundColor
          #   fieldGroupName
          #   textColor
          #   title
          #   content {
          #     fieldGroupName
          #     contentBody {
          #       bodyCopy
          #       fieldGroupName
          #       imageVideoSide
          #       title
          #       videoId
          #       image {
          #         sourceUrl
          #       }
          #     }
          #   }
          # }
          # ... on WpPost_Sections_Sections_Featurette {
          #   contentBody
          #   contentColor
          #   contentHeading
          #   contentSide
          #   fieldGroupName
          #   image {
          #     sourceUrl
          #   }
          #   textColor
          # }
        }
      }
    }
  }
`
